import { setup, Vue } from "vue-class-component";
import { useI18n } from "@/shared/composables/use-i18n";
import { confirmPopupModel } from "@/core/confirm-popup/confirm.model";

export class ConfirmPopup extends Vue {
    i18n = setup(useI18n);
    model = setup(() => confirmPopupModel);

    // get submitBtnText() {
    //     return this.model.type === "info"
    //         ? "common.ok"
    //         : "dashboard.myAccountComponent.companyInfoTab.teamMembers.verifiedYes";
    // }
}
